import { Icon } from "@iconify/react";
import React, { useState } from "react";
import { useLocation} from "react-router-dom";
import { api } from "../../utils/apiClient";
import { toast } from "react-toastify";

const ResetPassword = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token"); // read token from URL query

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!token) {
            setError("Invalid or expired reset link");
            return;
        }

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        try {
            setLoading(true);

            const res = await api.post(`/reset-password`, {
                token,
                password,
            });


            toast.success(res.data.message, {
                autoClose: 2500,
                onClose: () => closeRemoteTab(),
            });

        } catch (err) {
            setError(err.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };


    const closeRemoteTab = () => {
        window.close();

        // fallback if browser blocks it
        setTimeout(() => {
            document.body.innerHTML = `
            <div style="
                    display:flex;
                    flex-direction:column;
                    justify-content:center;
                    align-items:center;
                    height:100vh;
                    font-family:Arial;
                ">
                    <div style="font-size:64px;color:#22c55e;">✔</div>
                    <h2 style="margin-top:10px;">Password Reset Completed</h2>
                    <p style="color:#666;">
                        You may safely close this tab now.
                    </p>
                </div>
        `;
        }, 300);
    };

    return (
        <section className="auth bg-base d-flex flex-wrap">
            <div className="auth-right py-32 px-24 d-flex align-items-center justify-content-center w-100">
                <div className="max-w-464-px mx-auto w-100">
                    <div className="center-all mb-24">
                        <img src="/assets/images/app_logo.webp" alt="Logo" />
                        <h5 className="mt-12">Reset Password</h5>
                    </div>

                    {error && <p className="text-danger mb-16">{error}</p>}

                    <form onSubmit={handleSubmit}>
                        {/* New Password */}
                        <div className="position-relative mb-20">
                            <div className="icon-field">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="solar:lock-password-outline" />
                                </span>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control h-56-px radius-12"
                                    placeholder="New Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        {/* Confirm Password */}
                        <div className="position-relative mb-20">
                            <div className="icon-field">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="solar:lock-password-outline" />
                                </span>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control h-56-px radius-12"
                                    placeholder="Confirm Password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </div>

                            <span
                                className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary w-100 radius-12"
                            disabled={loading}
                        >
                            {loading ? "Resetting..." : "Reset Password"}
                        </button>
                    </form>

                    {/* <div className="text-center mt-16">
            <Link to="/login">Back to Login</Link>
          </div> */}
                </div>
            </div>
        </section>
    );
};

export default ResetPassword;
